import taskTypeLargeIcon from '@atom/components/common/svgIcons/taskTypeLarge.svg';
import { Progress } from '@atom/mui';

import classes from './taskCreate.module.css';

interface Props {
  taskTemplatesLoading: boolean;
}

const EmptySearchTemplate = ({ taskTemplatesLoading }: Props) => {
  return taskTemplatesLoading ? (
    <Progress />
  ) : (
    <div className={classes.emptyTaskTemplateContainer}>
      <img src={taskTypeLargeIcon} />
      <div className={classes.emptyTitle}>No Search Results</div>
    </div>
  );
};

export default EmptySearchTemplate;
